/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function DataScience(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <path
        d="M12 21V21C7.02944 21 3 16.9706 3 12V12V12V12C3 7.02944 7.02944 3 12 3H12C16.9706 3 21 7.02944 21 12V12C21 16.9706 16.9706 21 12 21L12 21Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.37 14.33H9.627M10.333 7.667V7.667C10.333 6.74634 11.0793 6 12 6V6C12.9207 6 13.667 6.74634 13.667 7.667V7.667C13.667 8.58766 12.9207 9.334 12 9.334C12 9.334 12 9.334 12 9.334V9.334C11.0796 9.33345 10.3335 8.58743 10.333 7.667H10.333ZM6.293 14.333V14.333C6.293 13.4123 7.03934 12.666 7.96 12.666V12.666C8.88066 12.666 9.627 13.4123 9.627 14.333V14.333V14.333C9.62645 15.2534 8.88043 15.9994 7.96 16V16C7.03934 16 6.293 15.2537 6.293 14.333C6.293 14.333 6.293 14.333 6.293 14.333L6.293 14.333ZM14.373 14.333V14.333C14.373 13.4123 15.1193 12.666 16.04 12.666H16.04C16.9607 12.666 17.707 13.4123 17.707 14.333V14.333V14.333C17.707 15.2537 16.9607 16 16.04 16C16.04 16 16.04 16 16.04 16V16C15.1193 16 14.373 15.2537 14.373 14.333H14.373ZM12.9 9.07L15.319 12.829L12.9 9.07ZM11.094 9.07L8.687 12.829L11.094 9.07Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

DataScience.defaultProps = {
  color: "currentColor",
  size: 24,
};

DataScience.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
